import React from "react";
import useResponsive from "../../core/hooks/useResponsive";
import { TwoColumn, TwoRow } from "../../core/layouts";
import variables from "../../themes/base/styles/variables";

export default function AssignSubProductToQuestionnaireLayout({
  leftSection,
  rightSection,
}) {
  const responsive = useResponsive();
  return responsive.isSm ? (
    <TwoColumn
      style={{ width: variables.fullWidth }}
      leftSection={leftSection}
      rightSection={rightSection}
      leftSectionStyle={{ flexShrink: 1 }}
      rightSectionStyle={{ flexShrink: 1 }}
      isLeftFillSpace
      isRightFillSpace
    />
  ) : (
    <TwoRow topSection={leftSection} bottomSection={rightSection} />
  );
}
